module.exports = __webpack_public_path__ + "img/hydraulic_arm_instructions_button.188a41d8.png";